import { PageModuleResolver } from 'components/common/PageModuleResolver';
import { PageWrapper } from 'components/common/PageWrapper';
import { Seo } from 'components/common/Seo';
import { PartnerHero } from 'components/heros/PartnerHero';
import { usePartner } from 'hooks/pages/usePartner';
import { useRatingsOverview } from 'hooks/reviews/useRatingsOverview';
import { useRouter } from 'next/router';
import { addReviewsToOverline } from 'utils/addReviewsToOverline';

export const Partner = () => {
  const router = useRouter();
  const { slug } = router.query;
  const { data: partner } = usePartner(slug as string);
  const { data: ratingsOverview } = useRatingsOverview();

  const { title, video, image, name, role, overline, quote, cta, blocks, seo } =
    partner;

  const heroOverline = overline
    ? addReviewsToOverline(overline, ratingsOverview)
    : undefined;

  const anchorBlock = blocks?.find(
    (block) =>
      block._type === 'timeline_productBlock' ||
      block._type === 'productBundle' ||
      block._type === 'timeline_supplementPicker' ||
      block._type === 'timeline_skincareFormatPicker' ||
      block._type === 'timeline_signupBanner',
  );

  return (
    <PageWrapper>
      <Seo
        noindex
        seo={{
          title: seo?.title ?? title,
          description: seo?.description ?? quote,
          image: seo?.image || image || undefined,
        }}
      />
      <PartnerHero
        image={image}
        video={video?.cloudinaryId ? video : undefined}
        overline={heroOverline}
        quote={quote}
        name={name}
        role={role}
        cta={cta}
        anchorBlock={anchorBlock}
      />
      {blocks && <PageModuleResolver blocks={blocks} />}
    </PageWrapper>
  );
};
